import React, {Fragment} from 'react'
import { graphql, StaticQuery } from 'gatsby'


class Content extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        const {bubblePink, bubbleBlue, juniorBank, juniorHouseOrrange, juniorHouseGreen} = this.props.query;
        const {device} = this.props;

        
            return (
				<Fragment>
                    <section className="middle-sec junior-sec">
                        <div className="custom-container">       
                         <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12 for-mobile">
                                <figure><img src={bubblePink.publicURL}/></figure>
                            </div>                 
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                <figcaption>
                                    <h3>Ett lugnt formspråk <br/>  för barn </h3>
                                    <p className="desktop">Juniors färger, illustrationer och övningar är framtagna <br/> för att öka koncentrationen och skapa ett lugn hos <br/> eleven. Innehållet är lättnavigerat och spelinspirerat <br/> med övningar som grundar sig i läroplanen.</p>
                                    <p className="for-mobile">Juniors färger, illustrationer och övningar är <br/> framtagna för att öka koncentrationen och skapa ett <br/> lugn hos eleven. Innehållet är lättnavigerat och <br/> spelinspirerat med övningar som grundar sig i läroplanen.</p>                                    
                                </figcaption>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12 desktop">
                                <figure><img src={bubblePink.publicURL}/></figure>
                            </div>
                        </div>
                    </section>
                    
                    <section className="man-section second junior-sec">
                        <div className="custom-container">
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                <figure>
                                    <img src={bubbleBlue.publicURL}/>
                                </figure>
                            </div>
                            
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                <figcaption className="sec-sec">
                                    <h3>Matematik från <br/> verkliga livet </h3>
                                    <p className="desktop">Innehållet i Junior har utvecklats av erfarna lärare, <br/> pedagoger och forskare. Övningarna skapar nyfikenhet <br/> kring matematik och hjälper barnen att använda matten <br/> i verkliga livet. Lättförståeligt och alltid tillgängligt.</p>
                                    <p className="for-mobile">Innehållet i Junior har utvecklats av erfarna lärare, <br/> pedagoger och forskare. Övningarna skapar <br/>  nyfikenhet kring matematik och hjälper barnen att <br/>  använda matten i verkliga livet. Lättförståeligt och <br/> alltid tillgängligt.</p>
                                </figcaption>
                            </div>
                        </div>
                    </section>
                    
                    <section className="albert-three junior-three">
                        <div className="custom-container">
                            <ul>
                                <li>
                                    <figure><img src={juniorBank.publicURL}/></figure>
                                    <figcaption>
                                        <h4>Innehåll baserat <br/> på forskning</h4>
                                        <p className="desktop"> Grundlig forskning säkerställer att ditt barn lär sig i enlighet med skolplanen och skapar förutsättningar inför mer komplicerade matteuppgifter längre fram.</p>
                                        <p className="for-mobile">Grundlig forskning säkerställer att ditt barn lär <br/>sig i enlighet med skolplanen och skapar <br/> förutsättningar inför mer komplicerade <br/> matteuppgifter längre fram.</p>
                                    </figcaption>
                                </li>
                                <li>
                                    <figure><img src={juniorHouseGreen.publicURL}/></figure>
                                    <figcaption>
                                        <h4>Oändligt antal <br/> interaktiva övningar</h4>
                                        <p className="desktop">Alberts interaktiva uppgifter gör det roligt för barn att förstå och lära sig matematik. Engagerande och underhållande övningar är grunden för en god lärupplevelse för yngre barn.</p>
                                        <p className="for-mobile">Alberts interaktiva uppgifter gör det roligt för barn att <br/> förstå och lära sig matematik. Engagerande och <br/> underhållande övningar är grunden för en <br/> god lärupplevelse för yngre barn.</p>

                                        
                                        
                                    </figcaption>
                                </li>
                                <li>
                                    <figure><img src={juniorHouseOrrange.publicURL}/></figure>
                                    <figcaption>
                                        <h4>Spelinspirerad <br/> upplevelse</h4>
                                        <p className="desktop">En spelinspirerad kunskapsresa där ditt barn <br/> når nya nivåer genom utmaningar och positiv feedback. Tillsammans med Albert utvecklas barn i sin egen takt på ett underhållande och inspirerande sätt.</p>
                                        <p className="for-mobile">En spelinspirerad kunskapsresa där ditt barn <br/> når nya nivåer genom utmaningar och positiv <br/> feedback. Tillsammans med Albert utvecklas <br/> barn i sin egen takt på ett underhållande och <br/> inspirerande sätt.</p>
                                    </figcaption>
                                </li>
                            </ul>
                        </div>
                    </section>
                </Fragment>
            )
        
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    bubblePink: file(relativePath: {regex: "/jr-small-illustration-bubble-pink/"}) {
                        publicURL
                    }
                    bubbleBlue: file(relativePath: {regex: "/jr-small-illustration-bubble-blue/"}) {
                        publicURL
                    }
                    juniorBank: file(relativePath: {regex: "/group-19/"}) {
                        publicURL
                    }
                    juniorHouseGreen: file(relativePath: {regex: "/group-20/"}) {
                        publicURL
                    }
                    juniorHouseOrrange: file(relativePath: {regex: "/group-25/"}) {
                        publicURL
                    }
                }
                
                `
            }
        render={(data)  => (
           <Content query={data} {...props}/>
        )}
    />
)